import styled from 'styled-components';
import {theme} from '@styles/theme';

export const SystemDetailsPageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SystemDetailsContentWrapper = styled.div`
  width: calc(100% - 48px);
  height: 100%;
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 64px;
`;

export const SystemDetailSystemInfoWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SystemDetailsUsersBlock = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const EditUserBtn = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.basic07};
  border-radius: 32px;
  cursor: pointer;
`;

export const SystemDetailsCoverageBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SystemDetailsCoverageTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SystemDetailsCoverageBtnsWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;